// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".minicalender20200405 {\n  height: 370px;\n  overflow: auto;\n  width: 100%;\n  display: flex; }\n  .minicalender20200405 .minicalender20200405flexbox {\n    flex-basis: 230px; }\n", ""]);
// Exports
module.exports = exports;
